var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isNumber
    ? _c("w-input-number", {
        attrs: {
          disabled: _vm.disabled,
          value: _vm.computedValue,
          label: _vm.label,
          fancy: "",
          decimals: _vm.decimals,
        },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return _vm.onEnter($event)
          },
        },
      })
    : _vm.isBoolean
    ? _c(
        "w-row",
        [
          _c("w-col", { attrs: { xs: "12" } }, [
            _vm._v(" " + _vm._s(_vm.label) + " "),
          ]),
          _c(
            "w-col",
            { attrs: { xs: "6" } },
            [
              _c("w-radio", {
                attrs: {
                  disabled: _vm.disabled,
                  name: _vm.radioName,
                  checked: !_vm.computedValue,
                  label: _vm.$ct("boolean-value-false"),
                },
                on: {
                  input: function ($event) {
                    return _vm.onBooleanInput(false)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "6" } },
            [
              _c("w-radio", {
                attrs: {
                  disabled: _vm.disabled,
                  name: _vm.radioName,
                  checked: _vm.computedValue,
                  label: _vm.$ct("boolean-value-true"),
                },
                on: {
                  input: function ($event) {
                    return _vm.onBooleanInput(true)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm.isDate
    ? _c("w-date-picker", {
        attrs: {
          disabled: _vm.disabled,
          value: _vm.computedValue,
          label: _vm.label,
          fancy: "",
        },
        on: {
          input: function ($event) {
            return _vm.onDateInput($event)
          },
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return _vm.onEnter($event)
          },
        },
      })
    : _vm.isDuration
    ? _c("app-duration-input", {
        attrs: {
          disabled: _vm.disabled,
          value: _vm.computedValue,
          label: _vm.label,
          fancy: "",
        },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return _vm.onEnter($event)
          },
        },
      })
    : _c("w-input", {
        attrs: {
          disabled: _vm.disabled,
          value: _vm.computedValue,
          label: _vm.label,
          fancy: "",
        },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return _vm.onEnter($event)
          },
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }